import { Card } from '@alexpireddu/map-ui';
import styled from '@emotion/styled';
import { FC } from 'react';
import { useAppSelector } from '../../hooks';
import { colors } from '../../theming/theme';
import MenuLinks from './MenuLinks';
import UserBox from './UserBox';

const ContentContainer = styled(Card)({
  maxWidth: '264px',
  width: '264px',
});

const Divider = styled.div({
  marginLeft: '-24px',
  marginRight: '-24px',
  borderBottom: 'solid 1px ' + colors.grey300,
  marginTop: '24px',
  marginBottom: '24px',
});

const Content: FC = () => {
  const { user } = useAppSelector((store) => ({
    user: store.user.data,
  }));

  return (
    <ContentContainer size="lg">
      <UserBox user={user} />
      <Divider />
      <MenuLinks />
    </ContentContainer>
  );
};

export default Content;
